module.exports = __webpack_public_path__ + "img/PULL.3c064464.svg";